import { PhotoCamera, AccountBalance, People, Leaderboard } from '@mui/icons-material';
import { Company, RoleEmployee, RoleUser } from '@homesusa/core';
import { AppType, appTypeUrl, SidebarItemType } from '../enums';
import { SidebarItem } from '../interfaces';
import { getSidebarEndpoint } from './get-sidebar-endpoint';
import {
  getQuicklisterReleaseNotes,
  getQuicklisterSidebarItems
} from './quicklister-sidebar-items';

export const getCommonSidebarItems = (currentCompany?: Company): Record<string, SidebarItem> => {
  const allowedEmployeeRoles = [RoleEmployee.CompanyAdmin, RoleEmployee.CompanyAdminReadonly];
  const excludeUserRoles = [RoleUser.Photographer];
  return {
    [SidebarItemType.LeadManagement]: {
      title: 'Lead',
      allowedEmployeeRoles,
      excludeUserRoles,
      icon: Leaderboard,
      items: [
        {
          title: 'Emails',
          endpoint: getSidebarEndpoint(AppType.LeadManagement, 'lead-emails')
        },
        {
          title: 'Phones',
          endpoint: getSidebarEndpoint(AppType.LeadManagement, 'lead-phones')
        }
      ]
    },
    [SidebarItemType.PhotoService]: {
      title: 'Photo Services',
      icon: PhotoCamera,
      items: [
        {
          title: 'Requests',
          endpoint: getSidebarEndpoint(AppType.PhotoService, 'photo-requests')
        },
        {
          title: 'Manage Photographers',
          allowedUserRoles: [RoleUser.MLSAdministrator],
          endpoint: getSidebarEndpoint(AppType.PhotoService, 'photographers')
        }
      ]
    },
    [SidebarItemType.CompanyManagement]: {
      title: 'Company',
      icon: AccountBalance,
      allowedEmployeeRoles,
      excludeUserRoles,
      items: [
        {
          title: 'Company Profile',
          endpoint: getSidebarEndpoint(AppType.CompanyManagement, 'companies')
        },
        ...(!currentCompany
          ? [
              {
                title: 'Corporations',
                endpoint: getSidebarEndpoint(AppType.CompanyManagement, 'corporations'),
                allowedUserRoles: [RoleUser.MLSAdministrator]
              }
            ]
          : []),
        {
          title: 'MLS Information',
          endpoint: getSidebarEndpoint(AppType.CompanyManagement, 'mls-information'),
          allowedUserRoles: [RoleUser.MLSAdministrator]
        }
      ]
    },
    [SidebarItemType.UserManagement]: {
      title: 'Users',
      icon: People,
      allowedEmployeeRoles,
      excludeUserRoles,
      items: [
        {
          title: 'Manage Users',
          endpoint: `${appTypeUrl[AppType.UserManagement]}/users`
        }
      ]
    }
  };
};

export const sidebarItems = {
  ...getQuicklisterSidebarItems(),
  ...getCommonSidebarItems(),
  ...getQuicklisterReleaseNotes()
};
